import api from "../../api.service"
import { getPaginatedResponse } from "../utils"

import queryString from "query-string"

/**
 * Paginated list of an org's sign-offs (api/v2/signOff). Filters: type,
 * refId, mission, status[] (or open=true|false), approver ("me" or a person
 * id), requester ("me" or a person id), search, limit, sortBy, count.
 * The server narrows what the caller may see: an org admin everything, a
 * member of `mission` that project's, otherwise their own.
 *
 * @param orgId {String}
 * @param queryParams {Object}
 * @param [signal] {AbortSignal}
 * @return {Promise<{ value: Array, count?: Number, getNext: Function, hasNext: Function }>}
 */
export function getOrgSignOffs(orgId, queryParams = {}, signal) {
    const qs = queryString.stringify(queryParams)
    return api
        .get(`/v2/orgs/${orgId}/signOffs?${qs}`, { signal })
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}
